module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAP///2ZmZiH5BAAAAAAALAAAAAAMAAwAAAIXjI+pCt37AoBTVuRiivrw61WdkYHLiRYAOw=="